import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";
import "dayjs/locale/ja";
dayjs.locale("ja");

export default {
  name: "company-notice",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompanyNotice();
  },
  data() {
    return {
      companyNotices: [],
      getCompanyNoticeEnd: false
    };
  },
  computed: {},
  methods: {
    goCompanyNoticeNew() {
      this.$router.push({
        path: "/company_notice/new"
      });
    },
    async getCompanyNotice() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY_NOTICE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companyNotices = res.company_notices;
      this.getCompanyNoticeEnd = true;
    },
    async deleteCompanyNotice(companyNoticeId) {
      if (!window.confirm("本当に削除しますか？")) {
        return;
      }
      let res = await this.$store
        .dispatch("DELETE_COMPANY_NOTICE", {
          id: companyNoticeId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getCompanyNotice();
      } else {
        this.errorInfo = res.error;
      }
    },
    goCompanyNoticeEdit(companyNoticeId) {
      this.$router.push({ path: `/company_notice/${companyNoticeId}/edit` });
    },
    dateFormat(date) {
      return dayjs(date).format("YYYY年MM月DD日(ddd)");
    },
    beforeToday(date) {
      if (date < dayjs().format("YYYY-MM-DD")) {
        return true;
      } else {
        return false;
      }
    }
  }
};
